module.exports = __webpack_public_path__ + "static/img/logo_1.f6c09a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_1.png
// module id = Cz8E
// module chunks = 3